/* eslint-disable indent */
const Urls = {
  DOMAIN_YKT:
    process.env.VUE_APP_ENV === 'test'
      ? 'https://mobilelan.emoney.cn/yktapi'
      : process.env.VUE_APP_ENV === 'staging'
      ? 'https://yktpre.emoney.cn/yktapi'
      : 'https://yktapi.emoney.cn/',
  DOMAIN_STATIC:
    process.env.VUE_APP_ENV === 'test'
      ? 'https://mobilelan.emoney.cn/yktstatic'
      : process.env.VUE_APP_ENV === 'staging'
      ? 'https://yktpre.emoney.cn/yktstatic'
      : 'https://yktstatic.emoney.cn',
  DOMAIN_YOUKANTOUWAP:
    process.env.VUE_APP_ENV === 'test'
      ? 'https://mobilelan.emoney.cn/youkantou/m'
      : process.env.VUE_APP_ENV === 'staging'
      ? 'https://yktpre.emoney.cn/youkantou/m'
      : 'https://youkantou.emoney.cn/m'
}

export default Urls
